import { useEffect, useState } from "react";
import { organizerMeApi } from "../../api/api";

// Negocios habilitados a mano en el back (TICKETS_NEGOCIOS_MULTI_SEDE) pueden tener varios clubes y bares.
// El perfil del organizador trae `multiSede`; si el pedido falla se asume que no, que es la regla de siempre.
export default function useMultiSede() {
  const [multiSede, setMultiSede] = useState(false);

  useEffect(() => {
    let activo = true;
    (async () => {
      try {
        const res = await organizerMeApi();
        if (activo) setMultiSede(res?.data?.info?.multiSede === true);
      } catch (_) {
        /* sin perfil, sin botón: queda la regla de un club y un bar por negocio */
      }
    })();
    return () => {
      activo = false;
    };
  }, []);

  return multiSede;
}
